<nz-page-header title="Вход в профила"/>
<section class="mb-5 container-lg">
  <div class="row justify-content-center">
    <div class="col-12 col-md-8 col-xl-6">
      <div class="px-3 border rounded-3 shadow bg-light">
        <header class="py-4 mb-4 border-bottom d-flex align-items-center gap-3">
          <nz-logo height="50"/>
          <h1 class="text-muted">Collectoria</h1>
        </header>
        <main>
          <form [formGroup]="form">
            <fieldset class="mb-4">
              <label for="emailOrUsername" class="mb-0 form-label">Имейл или потребителско име*</label>
              <input
                id="emailOrUsername"
                type="text"
                formControlName="emailOrUsername"
                class="form-control"
                placeholder="Въведете имейл или потребителско име..."
                aria-label="Имейл или потребителско име"
                [class.is-valid]="emailOrUsername?.touched && emailOrUsername?.valid"
                [class.is-invalid]="emailOrUsername?.touched && emailOrUsername?.invalid">
              <p class="invalid-feedback m-0">Задължително поле!</p>
            </fieldset>
            <fieldset class="mb-4">
              <label for="password" class="mb-0 form-label">Парола*</label>
              <input
                id="password"
                type="password"
                formControlName="password"
                class="form-control"
                placeholder="Въведете парола..."
                aria-label="Парола"
                [class.is-valid]="password?.touched && password?.valid"
                [class.is-invalid]="password?.touched && password?.invalid">
              <p class="invalid-feedback m-0">Задължително поле!</p>
            </fieldset>
          </form>
          @if (!!errorMessage) {
            <div class="pb-4 text-danger">
              {{ errorMessage }}
            </div>
          }
          <button
            (click)="onSubmit()"
            [disabled]="googleLoginLoading || standardLoginLoading"
            class="w-100 mb-4 btn btn-nz-primary">
            @if (standardLoginLoading) {
              <span class="me-2 spinner-border spinner-border-sm"></span>
            }
            <span>Вход</span>
          </button>
          <button
            (click)="onClickGoogleLogin()"
            [disabled]="googleLoginLoading || standardLoginLoading"
            class="w-100 mb-4 btn btn-light border d-flex align-items-center justify-content-center">
            @if (googleLoginLoading) {
              <span class="me-2 spinner-border spinner-border-sm"></span>
            }
            <img src="https://cdn1.iconfinder.com/data/icons/google-s-logo/150/Google_Icons-09-512.png"
                 alt="Google"
                 class="google-icon"/>
            <span>Вход с Google</span>
          </button>
        </main>
        <footer class="mb-3 pt-3 d-flex justify-content-between border-top">
          <a aria-label="Регистрация"
             class="btn btn-link text-decoration-none"
             [routerLink]="[appRoutes.root, appRoutes.account, appRoutes.registration]">
            Регистрация
          </a>
          <a aria-label="Забравена парола"
             class="btn btn-link text-decoration-none"
             [routerLink]="[appRoutes.root, appRoutes.account, appRoutes.passwordRecovery]">
            Забравена парола
          </a>
        </footer>
      </div>
    </div>
  </div>
</section>
